import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=a87623f4"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports